var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "300px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "60px", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.ChineseName") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.chineseLabel,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "chineseLabel", $$v)
                  },
                  expression: "form.chineseLabel"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.EnglishName") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.englishLabel,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "englishLabel", $$v)
                  },
                  expression: "form.englishLabel"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.Coding") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.code,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.Icon") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.icon,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "icon", $$v)
                  },
                  expression: "form.icon"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.ModuleFile") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.actions,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "actions", $$v)
                  },
                  expression: "form.actions"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.H5Url") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.form.url,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "url", $$v)
                  },
                  expression: "form.url"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.ParentNode") } },
            [
              _c("el-input-number", {
                staticStyle: { width: "200px" },
                attrs: {
                  min: 0,
                  max: 99999999,
                  "controls-position": "right",
                  precision: 0
                },
                model: {
                  value: _vm.form.parentId,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "parentId", $$v)
                  },
                  expression: "form.parentId"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.Order") } },
            [
              _c("el-input-number", {
                staticStyle: { width: "200px" },
                attrs: {
                  min: 1,
                  max: 99999999,
                  "controls-position": "right",
                  precision: 0
                },
                model: {
                  value: _vm.form.orderIndex,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "orderIndex", $$v)
                  },
                  expression: "form.orderIndex"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Menu.Type") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.form.type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("Menu.Module"), value: 2 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("Menu.Component"), value: 1 }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.enterHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.Save")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }